/* KTE PDP 2.0 / sticky CTA mirrors the native Shopify Add to Cart.
   No new product form, no direct /cart/add requests, no gallery listeners. */
(() => {
 const init = (root=document) => {
  const sticky=document.querySelector('[data-kte-pdp2-sticky]');
  if(!sticky||sticky.dataset.ktePdpReady==='1')return;
  const main=document.querySelector('main[data-template^="product"]');
  const native=main?.querySelector('.product-details add-to-cart-component button[ref="addToCartButton"]');
  const click=sticky.querySelector('[data-kte-pdp2-sticky-buy]');
  const price=sticky.querySelector('[data-kte-pdp2-sticky-price]');
  if(!main||!native||!click||!price)return;
  sticky.dataset.ktePdpReady='1';
  const update=()=>{
   const isMobile=window.matchMedia('(max-width:749px)').matches;
   const dialogOpen=!!document.querySelector('dialog[open], .cart-drawer__dialog[open]');
   const scrolledPastNative=native.getBoundingClientRect().bottom<0;
   sticky.hidden=!isMobile||!scrolledPastNative||dialogOpen;
   const disabled=native.disabled||native.getAttribute('aria-disabled')==='true';
   click.disabled=disabled;
   click.querySelector('svg').style.display=disabled?'none':'';
   click.firstChild.textContent=disabled?'UNAVAILABLE ':'ADD TO CART ';
   const nativePrice=main.querySelector('.product-details [ref="priceContainer"] .price');
   if(nativePrice){
    const candidates=nativePrice.querySelectorAll('.price-item--sale,.price-item--regular');
    const target=[...candidates].find(el=>el.offsetParent!==null)||candidates[0]||nativePrice;
    const value=target.textContent?.trim();
    if(value&&value.length<45)price.textContent=value;
   }
  };
  let pending=false;
  const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;update()})};
  click.addEventListener('click',()=>{if(!native.disabled)native.click();});
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  main.addEventListener('change',schedule);
  document.addEventListener('variant:update',schedule);
  const source=main.querySelector('.product-details');
  if(source){
   const observer=new MutationObserver(schedule);
   observer.observe(source,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
  }
  const links=main.querySelectorAll('[data-kte-pdp2-size-link]');
  links.forEach(btn=>btn.addEventListener('click',()=>{
   const trigger=main.querySelector('[class*="wsp-size-chart-trigger"]');
   if(trigger){trigger.click();return}
   const sections=[...main.querySelectorAll('.product-details details')];
   const withChart=sections.find(el=>el.querySelector('table')||/size chart|measurements|fit & care/i.test(el.textContent||''));
   const accordion=withChart||sections[0];
   if(accordion){
    accordion.open=true;
    const destination=accordion.querySelector('table')||accordion;
    destination.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
    return;
   }
   const fallback=main.querySelector('.product-details .accordion')||main.querySelector('.product-details');
   fallback?.scrollIntoView({behavior:'smooth',block:'center'});
  }));
  update();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
 document.addEventListener('shopify:section:load',()=>init());
})();